import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { certificationActions } from 'app/redux/slices/certifications.slice';
import {
    selectAddedCertification,
    selectAllCertifications
} from 'app/redux/selectors/Certification/certifications.selector';
import { notificationSuccess } from 'app/redux/actions/Notification/notifications.actions';
import { ADD_CERTIFICATION_TO_USER_SUCCESS } from 'app/Snackbar/NotificationMessages';
import { Certification } from 'app/redux/models/Certification.model';
import { AppDispatch } from 'app/redux/rootReducer';

interface AddCertificationDialogProps {
    open: boolean;
    userId: number;
    userCertifications: Certification[];
    onClose: () => void;
}

export function AddCertificationDialog({ open, userId, userCertifications, onClose }: AddCertificationDialogProps) {

    const dispatch = useDispatch<AppDispatch>();

    const { data: allCertifications } = useSelector(selectAllCertifications);
    const { loading: isSaving } = useSelector(selectAddedCertification);

    const [certificationId, setCertificationId] = useState<number | ''>('');

    useEffect(() => {
        if(open) {
            setCertificationId('');
            dispatch(certificationActions.getAllCertifications());
        }
    }, [open]);

    const ownedCertificationIds = userCertifications.map((certification) => certification.id);
    const selectableCertifications = allCertifications
        .filter((certification) => !ownedCertificationIds.includes(certification.id))
        .sort((first, second) => first.name.localeCompare(second.name));

    const submit = () => {
        if(certificationId === '') {
            return;
        }

        dispatch(certificationActions.addCertificationToUser({ userId, certificationId }))
            .unwrap()
            .then(() => {
                dispatch(notificationSuccess(ADD_CERTIFICATION_TO_USER_SUCCESS));
                dispatch(certificationActions.getCertificationsByUserId(userId));
                onClose();
            })
            .catch(() => {
                // La notification d'erreur est déjà émise par le thunk.
            });
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" aria-labelledby="add-certification-dialog-title">
            <DialogTitle id="add-certification-dialog-title">Ajouter une certification</DialogTitle>
            <DialogContent>
                <div data-testid="certification-select">
                    <TextField
                        margin="dense"
                        name="certification"
                        label="Certification"
                        fullWidth
                        select
                        value={certificationId}
                        onChange={(event) => setCertificationId(Number(event.target.value))}
                    >
                        {selectableCertifications.map((certification) => <MenuItem key={certification.id} value={certification.id}>
                            {certification.name}
                        </MenuItem>)}
                    </TextField>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" data-testid="cancel-button">
                    Annuler
                </Button>
                <Button
                    onClick={submit}
                    color="primary"
                    disabled={certificationId === '' || isSaving}
                    data-testid="submit-button"
                >
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AddCertificationDialog;
